import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import CheckoutPage from './CheckoutPage';
import LoadingMessage from '../../components/LoadingMessage';

class Checkout extends Component {

  render(){
    const {isLoading} = this.props;
    if(isLoading) {
      return (
        <div className="map-page map-page__message">
          <LoadingMessage />
        </div>
      );
    }

    return (
      <div className="map-page map-page__default map-page__default-map-thumbnail">
        <CheckoutPage />
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    isLoading: state.checkout.isLoading,
  };
};

export default connect(mapStateToProps)(Checkout);



// WEBPACK FOOTER //
// ./src/containers/checkout/index.js